import { render, staticRenderFns } from "./RequestBlock.vue?vue&type=template&id=0c2e10c6&scoped=true"
import script from "./RequestBlock.vue?vue&type=script&lang=js"
export * from "./RequestBlock.vue?vue&type=script&lang=js"
import style0 from "./RequestBlock.vue?vue&type=style&index=0&id=0c2e10c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e10c6",
  null
  
)

export default component.exports